module.exports = __webpack_public_path__ + "static/2cfc529dc41879426b9da5f9266159ba.svg";